import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import * as _ from 'underscore';
import { LocalStorageService } from '../_services/local-storage.service';
import { PersonSearchService } from '../_services/person-search.service';
import { Highlights } from '../hire-person-search/Highlights';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, Validators } from '@angular/forms';
import { BulkRevealModalComponent } from '../bulk-reveal-modal/bulk-reveal-modal.component';
import { CampaignService } from '../_services/campaign.service';
import { CandidateService } from '../_services/candidate.service';
import { GlobalService } from '../_services/global.service';
import { SimilarCandidateFilterComponent } from '../similar-candidate-filter/similar-candidate-filter.component';
import { Router } from '@angular/router';
import { AiModalScComponent, SCPassData } from '../ai-modal-sc/ai-modal-sc.component';
import { Observable, Subject, from, of } from 'rxjs';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { SimilarityInsightsModalComponent } from '../similarity-insights-modal/similarity-insights-modal.component';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { JdDataService } from '../jd-data.service';
import { JdinsightsModalComponent } from '../jdinsights-modal/jdinsights-modal.component';
import { AtsResumeScreenService } from '../_services/ats-resume-screen.service';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { SessionStorageService } from '../_services/session-storage.service';
declare const clevertap;

type FFHUnicornTierOne = {
  fortune500: string[];
  unicorn: string[];
  tierOneSchools: string[];
};

@Component({
    selector: 'app-candidate-quick-view',
    templateUrl: './candidate-quick-view.component.html',
    styleUrls: ['./candidate-quick-view.component.scss'],
    standalone: false
})
export class CandidateQuickViewComponent implements OnInit {

  public revealableInfo: { key: string, text: string, data?: string | string[], can_reveal: boolean, icon: string, is_revealed?: boolean }[] = [];
  work_email: any;
  personal_email: any;
  phones: any;
  canShowPhone: boolean;
  canShowPersonal_email: boolean;
  canShowWork_email: boolean;

  hideLookingForMore: boolean = false
  showMoreContactDetails: boolean = false;
  loggedInUserName: string = ''

  get hasRevealableInfo() {
    return this.revealableInfo.length > 0;
  }

  get hasWorkEmail() {
    return !!(this.data.work_email && this.data.work_email.length);
  }

  get hasPersonalEmail() {
    return !!(this.data.personal_email && this.data.personal_email.length);
  }

  constructor(private _localStorageService: LocalStorageService,
     private personSearchService: PersonSearchService,
     private modalService: NgbModal,
     private _localstorageservice: LocalStorageService,
     private emailCampaignService: CampaignService,
     public candidateservice: CandidateService,
     public router: Router,
     private filterDataHandlerService: FilterDataHandlerService,
     private similarCandidateService: SimilarCandidateService,
      private jdDataService: JdDataService,
      private atsResumeScreenService: AtsResumeScreenService,
      private sessionStorageService: SessionStorageService
    ) {
    this.loggedInUserName =  this._localStorageService.getItem('ufname') + " " + this._localStorageService.getItem('ulname')
  }

  @Input() data: any;
  @Input() i: any;
  experience: any;
  formattedSkills: any = [];
  currentSchool: any;
  currentJobTitle: any;
  currentCompany: any;
  currentLocation: any = null;
  currentStartDate: any;
  currentTenure: any;
  totalTenure: any;
  uniqueProfiles: any = {};
  linkedin_url: any = null;
  facebook_url: any = null;
  twitter_url: any;
  github_url: any;
  stackoverflow_url: any;
  behance_url: any;
  dribbble_url: any;
  medium_url: any;
  quora_url: any;
  temp: any = {};
  @Output() childEvents = new EventEmitter<{action : string, data: any}>();
  @Output() refreshCurrentView: EventEmitter<any> = new EventEmitter();



  revealableInfoObj: any = {};
  revealContact: boolean = true;
  displayContactIcon: any = [];
  highlights: MatchHighlights;
  similarcandidate: boolean = false;

  coloursArray = ['#B9D4F4', '#B9D4F4', '#B9D4F4', '#FFF9D7', '#E1D8E9'];
  clonedExperience : any = []
  /**
   * Set when any one of experience has title
   */
  isPastExperienceToBeShown : false
  canShowContactText: boolean = true;
  @Input() highlightkeywords :any= [];

  primaryCompanyInformation:any = {};
  currentCompanyInformation:any  = {};
  vievmoresoircechip:boolean

  highlightsPillData = new Highlights();
  highlightsList: any[] = [];
  isShowAllChips: boolean = false;
  hilightsCount: number = 0;

  @Input() similarobjectdata: any;
  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;
  @ViewChild('addCandidateToScreenAiModal') addCandidateToScreenAiModal: TemplateRef<any>;
  emailFoundCount: number;
  campaignList: any;

  selectedCampaign: any;
  campaign_input = new UntypedFormControl(null, [Validators.required]);
  candidateIdentifier: number | null;
  successMessage: string;
  errorMessage: string;
  currentexplocation:string;
  /**To Know the pending status of api */
  isLoadingEmailCampaignApi: boolean = false;
  job_input= new UntypedFormControl(null, [Validators.required]);

  jobList: any[] = [];
  selectedJob: any = null;

  // ScreenAI modal state
  screenAiDuplicateCheckDone: boolean = false;
  isLoadingScreenAiApi: boolean = false;
  postAddMssg: string = '';
  addCandidateSuccess: boolean = false;

  private destroy$ = new Subject<void>();

  @Input() parent: string = null;
  positionCategories: any;
  similarElasticId: string;
  get showMatchedSkills() {
    return (this.data && this.data?.highlight && (this.data?.highlight['skills'] || this.data?.highlight['skills.keyword'])) ? true : false;
  }

  get otherSkillsLength() {
    return this.formattedSkills.length > 6 ? this.data.skills.length - 6 : this.data.skills.length - this.formattedSkills.length;
  }

  hasSomeFilter = false;
  hilightsChipCount: number = 0;
isSimilarCandidate: boolean = false;

  get isComingFromJD() {
    return this.jdDataService.isComingFromJobDescription;
  }
  @Input() parsedJDKeys: any = null;
  @ViewChild('addToEmailCampaignWithViewCampaign') addToEmailCampaignWithViewCampaign: TemplateRef<any>;
  campaignName: string = '';
    isDropdownOpen: boolean = false;

  ngOnInit(): void {
    const tabName = this._localStorageService.getItem('tabName');
    this.totalTenure = this.getFormattedTenure(this.data.totaltenure);

    this.similarcandidate = (tabName === "similarcandidate");
    if(this.similarcandidate || this.similarobjectdata) {
      this.highlights = getFormattedHighlights(this.data.highlight, this.similarobjectdata && this.similarobjectdata.data && this.similarobjectdata.data.totaltenure, this.similarobjectdata && this.similarobjectdata.data && this.similarobjectdata.data.currentlocation, this.similarobjectdata && this.similarobjectdata.data && this.similarobjectdata.data.locationregion, this.data.totaltenure ? this.data.totaltenure: null);
      this.similarElasticId = this.similarobjectdata?.elasticid;
    }
    this.segregateContactWithProviders();
    this.setHighlightsData();

    // This must be called after getFormattedHighlights and setHighlightsData
    this.updateVisibleHighlights();
    this.highlightsList = this.getTierOneCompanyAndSchoolHilights(this.data?.curatedtalentpooltags);
    this.currentLocation = this.data.location_name; // ? this.data.location_name : this.data.location_names && this.data.location_names.length ? this.data.location_names[0] : null;
    this.linkedin_url = this.data.linkedin_url;
    this.isSimilarCandidate = this.similarCandidateService.isListingCalledFromSimilarCandidate
    this.data.experience = this.data.experience.map(obj => {
      const startDate = obj.start_date ? moment(obj.start_date) : null;
      const endDate = moment(obj.end_date || new Date());
      const totalTenure = endDate.diff(startDate, 'years', true);
      obj.totaltenure = this.getFormattedTenure(totalTenure);
      if (obj.is_primary === true || obj.is_primary === 'true') {
        if(obj){
          this.primaryCompanyInformation = obj.company
          if(this.primaryCompanyInformation && this.primaryCompanyInformation['location']){
            this.primaryCompanyInformation['location'] = obj?.company?.location?.name ? obj?.company?.location?.name : obj.location_names[0]
          }
          if(obj.company && obj.company.name){
            this.currentCompany = obj.company.name;
          }
          if(obj.title && obj.title.name){
            this.currentJobTitle = obj.title.name;
          }
          if(obj.totaltenure){
            this.currentTenure = obj.totaltenure;
          }
          if(obj.location_names.length > 0) {
            this.currentexplocation = obj.location_names[0];
          }
          this.currentStartDate = startDate;
          // if(this.currentLocation == null){
          //   if(obj && obj.company && obj.company.location && obj.company.location.name){
          //     this.currentLocation = obj.company.location.name;
          //   }
          // }
        }
      }

      if (!this.currentCompany && !this.currentJobTitle) {
        const clonedExperience = this.data.experience.filter((obj) => obj.is_primary != true && obj.is_primary != 'true');
        if (clonedExperience && clonedExperience.length) {
          if (this.currentJobTitle == null) {
            this.currentJobTitle = clonedExperience[0].title.name;
          }
          if (this.currentCompany == null) {
            this.currentCompany = clonedExperience[0].company.name;
          }
        }
      };
      return obj;
    })

    const positionHierarchy = this.data?.positionhierachytags && this.data?.positionhierachytags?.length > 0 ? _.pluck(this.data.positionhierachytags, 'category'): [];
    if(positionHierarchy.length > 0) {
      const uniqCategories = _.uniq(positionHierarchy)
      this.positionCategories  = uniqCategories.toString();
    }

    this.clonedExperience = this.data.experience.filter(obj => obj.is_primary != true  && obj.is_primary != 'true');
    // if(this.clonedExperience && this.clonedExperience.length){
    //   if(this.currentLocation == null){
    //     this.currentLocation = this.clonedExperience[0].company.location.name
    //   }
    // }

    //check any experience has title.name then only show past exp
    this.isPastExperienceToBeShown = this.clonedExperience.some(exp=>{
        return exp.title && exp.title.name
    })
    // this.data.experience = this.data.experience.filter(obj => obj.is_primary != true  && obj.is_primary != 'true');

    // this.data && this.data.profiles && this.data.profiles.forEach(profile => {
    //   this.linkedin_url = this.data.linkedin_url ? this.data.linkedin_url : null;
    //   this.facebook_url = this.data.facebook_url ? this.data.facebook_url : null;
    //   this.twitter_url = this.data.twitter_url ? this.data.twitter_url : null;
    //   this.github_url = this.data.github_url ? this.data.github_url : null;
    //   this.stackoverflow_url = this.data.stackoverflow_url ? this.data.stackoverflow_url : null;
    //   this.behance_url = this.data.behance_url ? this.data.behance_url : null;
    //   this.dribbble_url = this.data.dribbble_url ? this.data.dribbble_url : null;
    //   this.medium_url = this.data.medium_url ? this.data.medium_url : null;
    //   this.quora_url = this.data.quora_url ? this.data.quora_url : null;

    //   if (!this.uniqueProfiles[profile.network]) {
    //     this.uniqueProfiles[profile.network] = profile;
    //     if (profile.network === "linkedin") {
    //       this.linkedin_url = profile.url;
    //     } else if(profile.network === "facebook") {
    //       this.facebook_url = profile.url;
    //     } else if(profile.network === "twitter") {
    //       this.twitter_url = profile.url;
    //     } else if(profile.network === "github") {
    //       this.github_url = profile.url;
    //     } else if(profile.network === "stackoverflow") {
    //       this.stackoverflow_url = profile.url;
    //     } else if(profile.network === "behance") {
    //       this.behance_url = profile.url;
    //     } else if(profile.network === "dribbble") {
    //       this.dribbble_url = profile.url;
    //     } else if(profile.network === "medium") {
    //       this.medium_url = profile.url;
    //     } else if(profile.network === "quora") {
    //       this.quora_url = profile.url;
    //     }
    //   }
    // });

    this.data && this.data.profiles && this.data.profiles.forEach(profile => {
      if (!this.uniqueProfiles[profile.network]) {
        this.uniqueProfiles[profile.network] = profile;
        if (profile.network === "linkedin") {
          if(profile.url && !this.linkedin_url) {
            this.linkedin_url = profile.url;
          }
        }
        else if(profile.network === "facebook") {
          this.facebook_url = profile.url;
        } else if(profile.network === "twitter") {
          this.twitter_url = profile.url;
        } else if(profile.network === "github") {
          this.github_url = profile.url;
        } else if(profile.network === "stackoverflow") {
          this.stackoverflow_url = profile.url;
        } else if(profile.network === "behance") {
          this.behance_url = profile.url;
        } else if(profile.network === "dribbble") {
          this.dribbble_url = profile.url;
        } else if(profile.network === "medium") {
          this.medium_url = profile.url;
        } else if(profile.network === "quora") {
          this.quora_url = profile.url;
        }
      }

    });

    // enter the revealable info here
    // this.pushRevealableInfo('personal_email', 'Personal Email', this.data.personal_emails, true, 'fas fa-envelope');
    // this.pushRevealableInfo('work_email', 'Professional Email', this.data.work_email, true, 'fas fa-briefcase');
    // this.data.emails && this.data.emails.forEach(email => {
    //   if(email.type == 'professional') {
    //     this.pushRevealableInfo('work_email', 'Professional Email', email.address, true, 'fas fa-briefcase');
    //   } else if(email.type == 'personal') {
    //     this.pushRevealableInfo('personal_email', 'Personal Email', email.address, true, 'fas fa-envelope');
    //   }
    // });
    // this.pushRevealableInfo('mobile_phone', 'Phone Number', this.data.mobile_phone, true, 'fas fa-phone');

    // this.pushRevealableInfo('mobile_phone', 'Phone Number', this.data.phone_numbers, true, 'fas fa-phone');



    this.totalTenure = this.getFormattedTenure(this.data.totaltenure);


    if(this.data && this.data?.highlight && (this.data?.highlight['skills'] || this.data?.highlight['skills.keyword'])) {
      this.data.skills.forEach(skill => {
        let highlightData = null;
        const dataForHighlight = skill.trim().toLowerCase().replace(/<.*?>/g, '');
        if(this.data && this.data?.highlight && this.data?.highlight['skills'] ) {
          const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
          highlightFound && (highlightData = highlightFound);
        } if(this.data && this.data?.highlight && this.data?.highlight['skills.keyword'] ) {
          const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
          highlightFound && (highlightData = highlightFound);
        }
        highlightData && this.formattedSkills.push(highlightData);
      });
    }

    this.data.education = this.data.education.map(obj => {
      if (!(obj.degrees && obj.degrees.length)) {
        if (obj.majors && obj.majors.length) {
          obj.newField = obj.majors[0];
          return obj;
        }
        return obj;
      }

      if (obj.degrees && obj.degrees.length) {
        let degreeWords = obj.degrees[0].split(' ');
        if (degreeWords.length > 2) {
          obj.newField = obj.degrees[0];
        } else {
          let position = 0;
          for (let i = 1; i < obj.degrees.length; i++) {
            degreeWords = obj.degrees[i].split(' ');
            position = i;
            if (degreeWords.length > 2) {
              obj.newField = obj.degrees[i];
              return obj;
            }
          }
          if (obj.majors && obj.majors.length) {
            obj.newField = degreeWords[position] + ' in ' + obj.majors[0];
          }
        }
        if(!obj.newField) obj.newField = obj.degrees.toString().trim().replace(/'/g, "''");
        return obj;
      }
      return obj;
    });

    const clonedEducation = this.data?.education?.length ? this.data?.education[0] : null;
    if (clonedEducation) {
      this.currentSchool = clonedEducation?.school?.name
    };

    const haseuaccess = this._localStorageService.getItem('hasEUPersonSearchAccess');
  //  haseuaccess == 1 && this.selectedContinent.toString() == 'Europe' &&  this.showEUAccessModal();

    this.getAllScreenAIJobs();
    /**
     * This handles search with debouncing for screenai jobs
     */
    this.job_input.valueChanges
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((query: string) => {
          const q = (query || '').trim();
          return this.atsResumeScreenService.getAllScreenAIJobsBySource(q, 'create');
        }),
        takeUntil(this.destroy$)  // prevent memory leak
      )
      .subscribe((res: any) => {
        // Handle both the empty array shortcut and API response
        if (Array.isArray(res)) {
          this.jobList = res;
          return;
        }
        if (res.status === 'success') {
          this.jobList = res.data || [];
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined as any);
    this.destroy$.complete();
  }

  private updateVisibleHighlights() {
    let highlightsCount = 0;
    if (this.highlightsPillData.fetchUnicornCompanies?.length) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }
    if (this.highlightsPillData.fetchFortuneFH?.length) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }
    if (this.highlightsPillData.fetchTierOneSchools?.length) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }
    if (this.highlightsPillData.isTechie) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }

    if (this.highlightsPillData.fetchTalentIndustries?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if (this.highlightsPillData.fetchTalentIndustries?.length) {
      this.highlightsPillData.setTalentIndustries([]);
    }

    if (this.highlights?.regionname?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.regionname?.length) {
      this.highlights.regionname = null;
    }

    if (this.highlights?.companySizes?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.companySizes?.length) {
      this.highlights.companySizes = null;
    }

    if (this.highlights?.totalTenure?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.totalTenure?.length) {
      this.highlights.totalTenure = null;
    }

    if (this.highlights?.skills?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.skills?.length) {
      this.highlights.skills = null;
    }

    if (this.highlights?.titles?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.titles?.length) {
      this.highlights.titles = null;
    }

    if (this.highlights?.locationNames?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.locationNames?.length) {
      this.highlights.locationNames = null;
    }

  }

  /**
   *
   * Intialises all the fields necessary for showing candidate highlights
   *
   */
  private setHighlightsData() {
    this.highlightsPillData.setTechie(this.isCandidateTechie(this.data));
    this.highlightsPillData.setTalentIndustries(this.getTalentIndustries(this.data?.experience));
    const extraHighlightsDetails = this.getFFHUnicornAndTierOne(this.data?.curatedtalentpooltags);
    this.highlightsPillData.setUnicornCompanies(extraHighlightsDetails.unicorn);
    this.highlightsPillData.setFortuneFH(extraHighlightsDetails.fortune500);
    this.highlightsPillData.setTierOneSchools(extraHighlightsDetails.tierOneSchools);
  }

  /**
   *
   * @returns An object with list of fortune five hundred, unicorn experience, and tier 1 school experience details.
   *
   */
  private getFFHUnicornAndTierOne(curatedtalentpooltags) : FFHUnicornTierOne {
    const res = {
      fortune500 : [],
      unicorn : [],
      tierOneSchools : []
    };
    if (!curatedtalentpooltags)
      return res;
    for (let el of curatedtalentpooltags) {
      if (el?.type === "experience" && el?.displayname?.toLowerCase() === "fortune-500" && !!el?.name) { res.fortune500.push(el?.name); }
      else if (el?.type === "experience" && el?.displayname?.toLowerCase() === "unicorns" && !!el?.name) { res.unicorn.push(el?.name); }
      else if (el?.type === "education" && el?.displayname?.toLowerCase() === "tier-1 school" && !!el?.name) { res.tierOneSchools.push(el?.name); }
    }
    res.fortune500 = _.uniq(res.fortune500);
    res.unicorn = _.uniq(res.unicorn);
    res.tierOneSchools = _.uniq(res.tierOneSchools);
    return res;
  }

  private getTierOneCompanyAndSchoolHilights(curatedtalentpooltags: any[]) {
    const highlightsFormatedData: any[] = [];
      const grouped: Record<string, any> = {};

    if (this.highlightsPillData.fetchTalentIndustries && this.highlightsPillData.fetchTalentIndustries.length) {
      grouped['fetchTalentIndustries'] = { label: "Multi-Industry", value: this.highlightsPillData.fetchTalentIndustries, color: "blue", imageName: "multi-industry" }
    }

    if (this.highlightsPillData.fetchUnicornCompanies && this.highlightsPillData.fetchUnicornCompanies.length) {
      grouped['fetchUnicornCompanies'] = { label: "Unicorn Experience", value: this.highlightsPillData.fetchUnicornCompanies, color: "yellow", imageName: "unicorn-experience" }
    }

    if (this.highlightsPillData?.isTechie) {
      grouped['isTechie'] = { label: "Techie", value: this.highlightsPillData.isTechie, color: "green", imageName: "techie" }
    }

    if (this.data?.currentjob_internal_movement || this.data?.progression_within_pastcompany) {
      grouped['PromotionTrack'] = { label: "Promotion Track", value: { currentjob_internal_movement: this.data?.currentjob_internal_movement, progression_within_pastcompany: this.data?.progression_within_pastcompany }, color: "yellow", imageName: "promotion-track" }
    }

    if (this.highlights?.locationNames) {
      grouped['SameLocation'] = { label: "Same Location", value: this.highlights?.locationNames, color: "green", imageName: "same-location" }
    }

    if (this.highlights?.regionname) {
      grouped['NearbyLocation'] = { label: "Nearby Location", value: this.highlights?.regionname, color: "green", imageName: "same-location" }
    }

    if (this.highlights?.titles) {
      grouped['RoleCompatibility'] = { label: "Role Compatibility", value: this.highlights?.titles, color: "title", imageName: "role-compatibility" }
    }

    if (this.highlights?.totalTenure) {
      grouped['YearsOfExperience'] = { label: "Years of Experience", value: this.highlights?.totalTenure, color: "yearsofexp", imageName: "years-of-experience" }
    }

    if (this.highlights?.companySizes) {
      grouped['CompanySize'] = { label: "Company Size", value: this.highlights?.companySizes, color: "pink", imageName: "company-size" }
    }

    if (this.highlights?.skills) {
      grouped['SkillsMatched'] = { label: "Skills Matched", value: this.highlights?.skills, color: "skills", imageName: "skills-matched" }
    }

    const displayNameConfig: any = {
      "maang": { label: "MAANG", color: "maang", imageName: "maang" },
      "dax 40": { label: "DAX 40", color: "dax", imageName: "dax40" },
      "nasdaq 100": { label: "NASDAQ 100", color: "nasdaq", imageName: "nasdaq100" },
      "nifty 50 / sensex": { label: "Nifty 50 / Sensex", color: "nifty", imageName: "nifty50" },
      "fortune-500 us": { label: "Fortune Global 500", color: "fortuneGlobal", imageName: "fortuneglobal500" },
      "s&p 500": { label: "S&P 500", color: "sp", imageName: "sp500" },
      "big four": { label: "Big 4", color: "bigfour", imageName: "big4" },
      "dow 30": { label: "DOW 30", color: "dow", imageName: "dow30" },
      "fortune-500": { label: "Fortune 500", color: "fortune", imageName: "fortune500" },
      "big oil": { label: "Big Oil", color: "bigoil", imageName: "bigoil" },
      "ftse 100": { label: "FTSE 100", color: "ftse", imageName: "ftse100" },
      "u15 group (canada)": { label: "U15 Group (Canada)", color: "u15group", imageName: "u15" },
      "batx": { label: "BATX", color: "batx", imageName: "batx" },

      "tier-1 school": { label: "Tier-1 School", color: "teal", imageName: "tier1school" },
      "c9 league (china)": { label: "C9 League (China)", color: "c9League", imageName: "c9" },
      "ivy league (usa)": { label: "Ivy League (USA)", color: "ivy", imageName: "ivy" },
      "group of eight (australia)": { label: "Group of Eight (Australia)", color: "navy", imageName: "go8" },
      "russell group (uk)": { label: "Russell Group (UK)", color: "groupOfEight", imageName: "russell" },
    };


  if(curatedtalentpooltags && curatedtalentpooltags?.length){
    for (let el of curatedtalentpooltags) {
      if (!el?.displayname || !el?.name) continue;

      const key = el.displayname.toLowerCase().trim();
      const config = displayNameConfig[key];
      if (!config) continue;

      if (!grouped[key]) {
        grouped[key] = {
          id: Object.keys(grouped).length + 1,
          label: config.label,
          value: [],
          color: config.color,
          imageName: config.imageName
        };
      }

      if (!grouped[key].value.includes(el.name)) {
        grouped[key].value.push(el.name);
      }
    }
  }

    return Object.values(grouped);
  }


  viewMoreLess(text: string) {
    const content = document.getElementById(`highlights-list-${this.i}`);
    if (text === 'more') {
      content.style.height = '100%';
      this.isShowAllChips = true;
    } else {
      content.style.height = '30px';
      this.isShowAllChips = false;
    }
  };

  getTalentIndustries(experiences: any[]): any {

    let industries : {name: string; exp: {};}[] = [];

    experiences.forEach(el => {
      if (!!el?.company?.industry)
        industries.push({
          name : el?.company?.industry,
          exp: this.getExperience(el)
        });
    });
    // industries = _.uniq(industries, x => x.name);

    let data = this.getUniqueIndustries(industries)
    return data;
  }

  getUniqueIndustries(industries){
  const uniqueData = this.uniqueExperience(industries);
  return uniqueData;

  }


  uniqueExperience(data) {
      const result = {};

      for (const item of data) {
          const key = `${item.name}`;

          if (result[key]) {
              if(item.exp.start_date == result[key].exp.start_date) {
                result[key].exp.year = item.exp.year;
                result[key].exp.month = item.exp.month;
              } else {
                 result[key].exp.year += item.exp.year;
                 result[key].exp.month += item.exp.month;

                while (result[key].exp.month >= 12) {
                    result[key].exp.year += 1;
                    result[key].exp.month -= 12;
                  }
              }
          } else {
              result[key] = {
                  name: item.name,
                  exp: { year: item.exp.year, month: item.exp.month, start_date: item.exp.start_date }
              };
          }
      }

      const uniqueAggregatedData = Object.values(result);
      return uniqueAggregatedData;
  }

  getExperience(obj: any) {

    let exp = {}

    if(obj.start_date && obj.end_date !==null &&  obj.start_date !==null){

      let startDate = obj.start_date;
      let endDate = obj.end_date;

      const startDateArray = startDate.split("-");
      const endDateArray = endDate.split("-");

      const startYear = parseInt(startDateArray[0], 10);
      const startMonth = parseInt(startDateArray[1], 10);
      const endYear = parseInt(endDateArray[0], 10);
      const endMonth = parseInt(endDateArray[1], 10);

      let yearDiff = endYear - startYear;
      let monthDiff = endMonth - startMonth;

      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }

      exp = {year:yearDiff, month:monthDiff, start_date: startDate}

    }else{

      if( obj.start_date !==null){
      let startDate = obj.start_date;
      const formattedDate = new Date();
      const year = formattedDate.getFullYear();
      const month = formattedDate.getMonth() + 1;
      const currentDate = `${year}-${month}`;

      const startDateArray = startDate.split("-");
      const endDateArray = currentDate.split("-");

      const startYear = parseInt(startDateArray[0], 10);
      const startMonth = parseInt(startDateArray[1], 10);
      const endYear = parseInt(endDateArray[0], 10);
      const endMonth = parseInt(endDateArray[1], 10);

      let yearDiff = endYear - startYear;
      let monthDiff = endMonth - startMonth;

      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }
      exp = {year:yearDiff, month:monthDiff, start_date: startDate}
      }
    }

    return exp;
  }

  openSliderSection($event, type) {
    // this.revealContact = false;
    let data = $event
    if($event == null){
      data = this.data
    }
    this.handleChildEvents('openNav', null, type, data)
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
      //loadn[0].style.display = 'block'
  }
    /**
   * Handles all child events
   * @param action type of action
   * @param event Evenet
   */
    handleChildEvents(action: string, event?: Event, type: any = null, contactIndex: any = null) {
      let eventData = {
        action: action,
        data: {
          ...this.data,
          highlights: this.highlights,
          highlightsPillData: this.highlightsPillData,
          selected: event ? (event.target as HTMLInputElement).checked : this.data.selected,
          currentIndex: this.i
        }
      }
      if(type  == 'show-contact'){
        eventData['type'] = 'show-contact'
      }else if(type == 'show-activity'){
        eventData['type'] = 'show-activity'
      } else if(type == 'show-skills') {
        eventData['type'] = 'show-skills'
      }
      this.childEvents.emit(eventData)
    }


  private pushRevealableInfo(key: string, text: string, data: string | string[], can_reveal: boolean = true, icon: string = 'fas fa-briefcase', is_revealed?: boolean) {
    // if (data && Array.isArray(data) && data.length) {
    //   data = data.filter(d => d && d.length);
    // }
    // if (data && typeof data === 'string' && data.length) {
    //   data = [data];
    // }
    // temp  changes for demo
    if(data){
      this.revealableInfo.push({
       key,
       text,
       data,
       can_reveal,
       icon,
       is_revealed
     });
    }


    // remove duplicates from revealable info based on key
    this.displayContactIcon = this.revealableInfo.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj['key']).indexOf(obj['key']) === pos;
    });

    this.revealableInfoObj = this.revealableInfo.reduce((acc, curr) => {
      if (!acc[curr.key]) {
        acc[curr.key] = [curr];
      } else{
        const isDuplicate = acc[curr.key].some((obj) => {
          return obj.data.some((d) => {
            return curr.data.includes(d);
          });
        }
        );
        if (isDuplicate) {
          return acc;
        } else {
          acc[curr.key].push(curr);
          return acc;
        }
      }
      return acc;
    }, {});

  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
    else if (type == 'website'){
      link = "https://www." + link;
    }
    window.open(link, "_blank")
  }

  viewmoredetails(data, i, type) {
    if (type == 'viewmore') {
      this.vievmoresoircechip= true
      document.getElementById(data + '_less' + i).style.display = 'none'
      document.getElementById(data + '_more' + i).style.display = 'block'
    } else {
      this.vievmoresoircechip= false

      document.getElementById(data + '_less' + i).style.display = 'block'
      document.getElementById(data + '_more' + i).style.display = 'none'
    }
  }

  isBoolean(value: any){
    if (typeof value == 'boolean' || value == 'true') {
      return true;
    }
    return false;
  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        // remove htmltag
        if (result.includes('<')) {
          return result.replace(/<.*?>/g, '');
        }

        return result;
      }
      return match;
    });

    return transformedValue;
  }

  /**
   * Highlight searched info in results
   * @param data input data to be processed for highlights
   * @param type type of data to be processed for highlights
   */
   highlightInfo(data: string, type: 'current_jobtitle' | 'past_jobtitle' | 'location' | 'skill' | 'currentjobtitle' | 'currentcompany' | 'pastcompany') {
    let keywords: any
    keywords = _.without(this.highlightkeywords, "AND","and","or","OR","not","NOT");
    if(data) {
     const dataForHighlight = data.trim().toLowerCase().replace(/<.*?>'/g, '').replace(/'/g, "");
    // const datafind = keywords.filter(x=>dataForHighlight.includes(x.replace(/[()*"]/g, '').toLowerCase().trim()));
    // if(datafind.length > 0) {
          let highlightedData: any= data;
          let highlightFound: any;
          switch (type) {
            case 'current_jobtitle':
              {
               if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name'] ) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
               } if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
               } if(this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
               } if(this.data && this.data?.highlight && this.data?.highlight['job_title']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
               }
             }

              break;
            case 'past_jobtitle':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.data && this.data?.highlight && this.data?.highlight['job_title']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 }
              }
              break;
            case 'location':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['location_name'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                } if(this.data && this.data?.highlight && this.data?.highlight['location_locality'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_locality'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                } if(this.data && this.data?.highlight && this.data?.highlight['location_name.keyword'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                }
                // const highlightFound = (this.data && this.data.highlight && this.data.highlight['location_name'] || this.data && this.data?.highlight && this.data?.highlight['location_locality'] || this.data && this.data?.highlight && this.data?.highlight['location_name.keyword'] || []).find((loc: string) => dataForHighlight.includes(loc.replace(/<.*?>/g, '').trim().toLowerCase()));

                // highlightFound && (highlightedData = highlightFound);
              }
              break;
            case 'skill':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['skills'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                } if(this.data && this.data?.highlight && this.data?.highlight['skills.keyword'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                }
             }
              break;
              case 'currentjobtitle':
                {
                  if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name'] ) {
                    const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
                    const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
                    const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.data && this.data?.highlight && this.data?.highlight['job_title']) {
                    const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   }
                }
                break;
            case 'currentcompany':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['job_company_name'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 }
              }
            break;
            case 'pastcompany':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['job_company_name'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 }
                 if(this.data && this.data?.highlight && this.data?.highlight['lastjob_company_name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['lastjob_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').replace(/'/g, "").trim().toLowerCase() === dataForHighlight.replace(/'/g, ""));
                  highlightFound && (highlightedData = highlightFound);
                 }


              }
            break;
          }

          return highlightedData;
      }

    //  }



    return data;
  }

  getkeywords(data) {
    const hightlights = this.highlightkeywords.find((skill: string) => data.replace(/<.*?>/g, '').includes(skill.toLowerCase().trim()));
    return hightlights;
  }

  selectRandomNumberForColor(){
    return Math.floor(Math.random() * this.coloursArray.length)
  }

  hideContactText(){
    this.canShowContactText = false;
  }

  toShowMoreContactDetails(){
    const falseValues = []
    Object.keys(this.data.contactDetails).forEach(x => {
      Object.keys(this.data.contactDetails[x]).forEach(y => {
        if(this.data.contactDetails[x][y] === false){
          falseValues.push(y)
        }
      })
    })


    if(falseValues && falseValues.length >= 1){
      return true
    }else{
      return false;
    }

  }

  segregateContactWithProviders(){
    if(this.data && this.data.existingContactDetails){
      this.work_email = this.data.existingContactDetails.filter(x => x.contactdetailcategory == "professional")
      this.personal_email = this.data.existingContactDetails.filter(x => x.contactdetailcategory == "personal")
      this.phones = this.data.existingContactDetails.filter(x => x.contactdetailcategory == null)

      if((this.work_email && this.work_email.length) ||
         (this.personal_email && this.personal_email.length) ||
         (this.phones && this.phones.length)){
          this.hideLookingForMore = false;
          this.showMoreContactDetails = true;

          if((this.work_email && this.work_email.length) &&
          (this.personal_email && this.personal_email.length) &&
          (this.phones && this.phones.length)){
            this.showMoreContactDetails = false;

          }

         }else{
          this.hideLookingForMore = false
          this.showMoreContactDetails = false
         }

      if(this.phones && this.phones.length){
        this.canShowPhone = true;
      }else{
        this.canShowPhone = false;
      }

      if(this.personal_email && this.personal_email.length){
        this.canShowPersonal_email = true
      }else{
        this.canShowPersonal_email = false
      }

      if(this.work_email && this.work_email.length){
        this.canShowWork_email = true;
      }else{
        this.canShowWork_email = false;
      }
    }else{
      if(this.data && this.data.contactDetails && this.data.contactDetails.pdl){
        if(this.data.contactDetails.pdl.phone == true){
          this.canShowPhone = true;
        }else{
          this.canShowPhone = false
        }

        if(this.data.contactDetails.pdl.work_email == true){
          this.canShowWork_email = true;
        }else{
          this.canShowWork_email = false
        }

        if(this.data.contactDetails.pdl.personal_email == true){
          this.canShowPersonal_email = true;
        }else{
          this.canShowPersonal_email = false
        }
      }


      // if(this.data){
      //   if(this.data.contactDetails && this.data.contactDetails.pdl){
      //     if(this.data.contactDetails.pdl.phone == true && this.data.contactDetails.pdl.work_email == true && this.data.contactDetails.pdl.personal_email == true){
      //          this.showMoreContactDetails = false;
      //     }else{
      //         this.hideLookingForMore = true;
      //         this.showMoreContactDetails = true;
      //     }
      //   }
      // }
    }


    // if(this.canShowPhone == false && this.canShowPersonal_email == false && this.canShowWork_email == false ){
    //   this.showMoreContactDetails = false;
    // }
    // if(this.canShowPhone == true && this.canShowPersonal_email == true && this.canShowWork_email == true ){
    //   this.showMoreContactDetails = false;
    // }else {
    //   this.showMoreContactDetails = true;
    // }
  }

  convertEm(input: string): string {
    return input;
  }

  transformMultiple(data){

    const modifiedArray = []
    if(Array.isArray(data)){

      data.forEach(value => {
        modifiedArray.push(value.replaceAll('<em>', '').replaceAll('</em>', ''))
      })


    }
    return modifiedArray.join(' , ');
  }


  getLikelyToMoveIn(){

  }

  getCompanyInfo(type:string, data: any, event){
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    // this.currentCompanyInformation = {}
    let companyData;
    let pastCompanyData = data?.company

    if(type == 'main'){
      if(!this.primaryCompanyInformation?.website){
        return;
      }
      if(this.primaryCompanyInformation?.id || this.primaryCompanyInformation?.name){
        companyData = [
          {
            ...((this.primaryCompanyInformation?.id) && {id: this.primaryCompanyInformation?.id}),
            ...((this.primaryCompanyInformation?.name) && {name: this.primaryCompanyInformation?.name})
          }
        ]
      }

    }else if(type == 'past'){
      if(!pastCompanyData?.website){
        return;
      }
      companyData = [
        {
          ...((pastCompanyData?.id) && {id: pastCompanyData?.id}),
          ...((pastCompanyData?.name) && {name: pastCompanyData?.name})
        }
      ]
    }
    this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.data){
        let companyDetails = res.data[0]
        if(type != 'main'){
        this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : pastCompanyData.website
        this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : pastCompanyData?.name
        this.currentCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : pastCompanyData?.industry
        this.currentCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : pastCompanyData?.location?.name
        this.currentCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : pastCompanyData?.size
        this.currentCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : pastCompanyData?.linkedin_url
        this.currentCompanyInformation['companylogo'] = companyDetails.companylogo
        this.currentCompanyInformation['tags'] = companyDetails.tags
        this.currentCompanyInformation['id'] = companyDetails.id
        this.currentCompanyInformation['key_id'] = companyDetails.id
        this.currentCompanyInformation['facebook_url'] = companyDetails?.facebook_url ? companyDetails?.facebook_url : pastCompanyData?.facebook_url
        this.currentCompanyInformation['twitter_url'] = companyDetails?.twitter_url ? companyDetails?.twitter_url : pastCompanyData?.twitter_url

        }
        if(type == 'main'){
        this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
        this.primaryCompanyInformation['tags'] = companyDetails.tags
        this.primaryCompanyInformation['key_id'] = companyDetails.id

        }
          //loadn[0].style.display = 'block'

      }
    });
  }

  isCandidateTechie(data: any) : boolean {
    let isTechie = false;
    if (!!data.profiles && !!data.profiles.length) {
      isTechie = data.profiles.some(item => item.network == "stackoverflow");
    }
    isTechie = isTechie || !!data.github_url;
    return isTechie;
  }

  print(){
    this.temp = this.data.profiles;
    this.temp = _.uniq(this.temp, "network");

  }

  redirecttoSimilarList() {
    this.personSearchService.getdetailsfromlinkedin(this.linkedin_url).subscribe((res:any)=>{
      if(res.status == "success") {
        if(res.data) {
          const pastindustries = _.pluck(res.data.experience, 'company')
          const schools = _.pluck(res.data.education, 'school')
          const degrees = _.uniq(_.flatten(_.map(res.data.education, 'degrees')));
          const fieldOfStudy = _.uniq(
            _.flatten(
              _.map(res.data.education, 'majors').concat(_.map(res.data.education, 'minors'))
            )
          );
          const locations = []
          const locParts = [];

          res.data.location_locality && locParts.push(res.data.location_locality);
          res.data.location_region && locParts.push(res.data.location_region);
          res.data.location_country && locParts.push(res.data.location_country);

          if (locParts.length) {
            locations.push(locParts.join(', '));
          }

          const totalTenure = res.data.totaltenure || 0;
          let fromYrsOfExperience = 0;
          let toYrsOfExperinece = 0;

          if (!isNaN(totalTenure) && totalTenure >= 0) {
            if (totalTenure > 2) {
              fromYrsOfExperience = Math.floor(totalTenure - 2);
              toYrsOfExperinece = Math.ceil(totalTenure + 2);
            } else {
              fromYrsOfExperience = 0;
              toYrsOfExperinece = Math.ceil(totalTenure + 2);
            }
          }

           const similarObject = {
            jobtitle: res.data.job_title ? [{ key: res.data.job_title, isMandatory: true }] : [],
            jobcompanyname: res.data.job_company_name ? [{ key: res.data.job_company_name, isMandatory: false }] : [],
            jobindustryname: res.data.job_company_industry ? [{ key: res.data.job_company_industry, isMandatory: true }] : [],
            pastindustries: _.pluck(pastindustries, 'industry'),
            schools: schools && schools.length ? _.pluck(schools, 'name').map(el => ({key: el, isMandatory: false})) : [],
            currentlocation: _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
            skills: res.data.skills ? res.data.skills.map(s => ({ key: s, isMandatory: false })) : [],
            elasticid: res.data.id,
            companysize: res.data.job_company_size ? [{ key: res.data.job_company_size, isMandatory: false }] : [],
            fullname: res.data.full_name,
            linkedinurl: this.linkedin_url,
            isUploadedFromResume: false,
            locationregion: res.data.location_region,
            locationcontinent: res.data.location_continent,
            totaltenure: totalTenure,
            fromYrsOfExperience,
            toYrsOfExperinece

          }

          const modalRef = this.modalService.open(
            AiModalScComponent,
            { size: 'xl', windowClass: 'genAimodal',centered: true, backdrop: 'static', keyboard: false }
          );
          const modalInstance: AiModalScComponent = modalRef.componentInstance;
          modalInstance.similarCandidateData = {data: similarObject, calledfrom: 'view-similar-candidate'} as SCPassData;

          const modalResult$ = from(modalRef.result) as Observable<SCPassData>;
          modalResult$.subscribe(response => this.openSCFilterComponent(response));
        } else if(res.message == 'Person not found') {
        }
      }
    })

  }

  private openSCFilterComponent(scPassData: SCPassData) {
    this.personSearchService.passsimilarcandidatesdata(scPassData);
    const modalRef = this.modalService.open(
      SimilarCandidateFilterComponent,
      { size: 'xl', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false }
    );
    modalRef.result.then((res) => {
      if (res?.action === 'submit') {
        this.personSearchService.passsimilarcandidatesdata(res);
        this._localStorageService.setItem('similar-candidates-additional-filters', JSON.stringify(res));
        this.similarCandidateService.emitSimilarCandidateObsEvent(res);
        this._localStorageService.setItem('candidate', res);
        this.redirectToListingFromSC(res.calledfrom);
      }
    });
  }

  private redirectToListingFromSC(calledFrom: string) {
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", `${environment.frontendurl}/person/search/listing?type=${calledFrom}&redirectFrom=candidate-card`);
    downloadLink.setAttribute("target", "_blank");
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  openAddToEmailCampaign(){
    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop : 'static', keyboard : false });
  }

  onTypeAheadSearch(event: string): void {
    const query = event;
    this.emailCampaignService.getCampaigns({campaign_name: query, created_by: this._localstorageservice.getItem('userdata').userid, 'status[]': [1,2]}).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }

  // Add this function to handle the selection from the typeahead
  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }

  addToEmailCampaign() {
    this.isLoadingEmailCampaignApi = true;
    this.campaign_input.markAllAsTouched();
    if(this.campaign_input.valid && this.selectedCampaign){
      const campaign_id = this.selectedCampaign.campaign_id;
      let unsubscribedCandidateCount = 0;
      let payloadArray = (Array.isArray(this.data) ? this.data : [this.data]).map(x => {
        if(x?.is_unsubscribed){
          unsubscribedCandidateCount++;
          return;
        }
          return {
            firstname: x.first_name,
            target_name: x.full_name,
            target_id: null,
            target_meta: JSON.stringify({
              "candidatenumber": x.candidatenumber && x.candidatenumber.length? x.candidatenumber: null,
              "elastic_id": x.id,
              "title": x.job_title,
            }),

              //elastic || else send 0
            target_email: x.existingContactDetails && x.existingContactDetails.length ?
                          this.extractPreferredEmail(x.existingContactDetails) : null,

            is_active: true,
            created_on: new Date().toISOString(),
            updated_on: new Date().toISOString()
          };
      }).filter(Boolean);
      const updatedPayloadArray = payloadArray.filter(x => x);
      this.emailFoundCount = 0;
      updatedPayloadArray.forEach(element => {
        if (element.target_email)
          this.emailFoundCount++;
      }
      );

      if(unsubscribedCandidateCount > 0 && updatedPayloadArray.length === 0){
        this.closeActiveModal();
        this.toastmessage("Unsubscribed from Email Campaign", 'error');
        return;
      }
      this.campaignName = this.campaign_input.value;
      if (this.data['candidatenumber']) {
        this.emailCampaignService.createTarget(campaign_id, updatedPayloadArray).subscribe((res: any) => {
          if (res.status == 'success') {
            if (res.data && res.data.length) {
              this.refreshCurrentView.emit(this.data)
              this.showEmailCampaignCount()
              this.closeActiveModal();
                 const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
              setTimeout(() => {
                modalRef.close();
              }, 5000);
              /**
               * add email campaign
               */
                  const emaailCampaignParams = {
                    "User ID": this._localStorageService.getItem('userdata').userid,
                    "Candidate ID": this.data.id,
                    "Campaign Name": this.selectedCampaign.campaign_name
                  }
                  clevertap.event.push('Add Candidate to Email Campaign', emaailCampaignParams);
              if (this.emailFoundCount !== updatedPayloadArray.length){

                // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
                const bulkRevealPayLoad = {
                  enrichedFrom: "person-search-listing",
                  candidates: [],
                  campaign_id: campaign_id
                }

                res.data.map((arr) => {
                  if(!arr?.target_email){
                    bulkRevealPayLoad.candidates.push(
                      {
                        elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                        // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                        campaign_target_id: arr.campaign_target_id
                      }
                    );
                  }
                })
                this.openDetailsModal(campaign_id, bulkRevealPayLoad, this.emailFoundCount, updatedPayloadArray.length);
              }
            }
            else{
              this.closeActiveModal()
              this.toastmessage("Candidate already present in selected campaign", 'error')
            }
          }
          else if (res.status == 'failure') {
            this.closeActiveModal()
            this.toastmessage("candidate addition failed", "error");
          }
        }, (error: HttpErrorResponse) => {
            this.isLoadingEmailCampaignApi = false;
            if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
              const remainingTargets = error.error.remainingTargets;
              this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
            } else {
              this.toastmessage("Something went wrong", "error");
            }
            this.closeActiveModal();
          });
      }
      else {
        this.emailCampaignService.migrateCandidates({ elasticid: [this.data.id] }).subscribe((res: any) => {
          const newMeta = JSON.parse(updatedPayloadArray[0].target_meta);
          newMeta.candidatenumber = res.data[0].candidatenumber;
          updatedPayloadArray[0].target_meta = JSON.stringify(newMeta);
          Promise.all(updatedPayloadArray.map(async (x:any) => {
            x.target_email = await this.getContactDetails(newMeta.candidatenumber, this.selectedCampaign['email_pref']);
            return x;
          })).then((newPayload) => {

            this.emailCampaignService.createTarget(campaign_id, newPayload).subscribe((res: any) => {
              this.isLoadingEmailCampaignApi = false;
              if (res.status == 'success') {
                this.refreshCurrentView.emit(this.data)
                this.showEmailCampaignCount()
                this.closeActiveModal();
                   const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
              setTimeout(() => {
                modalRef.close();
              }, 5000);
              /**
               * add email campaign
               */
                  const emaailCampaignParams = {
                    "User ID": this._localStorageService.getItem('userdata').userid,
                    "Candidate ID": this.data.id,
                    "Campaign Name": this.campaign_input.value
                  }
                  clevertap.event.push('Add Candidate to Email Campaign', emaailCampaignParams);
                if (this.emailFoundCount !== updatedPayloadArray.length){

                  // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
                  const bulkRevealPayLoad = {
                    enrichedFrom: "person-search-listing",
                    candidates: [],
                    campaign_id: campaign_id
                  }

                  res.data.map((arr) => {
                    bulkRevealPayLoad.candidates.push(
                      {
                        elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                        candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                        campaign_target_id: arr.campaign_target_id
                      }
                    );
                  })
                  this.openDetailsModal(campaign_id, bulkRevealPayLoad, this.emailFoundCount, newPayload.length);
                }
              }
              else if (res.status == 'failure') {
                this.closeActiveModal()
                this.toastmessage("candidate addition failed", "error");
              }
            }, (error: HttpErrorResponse) => {
                  this.isLoadingEmailCampaignApi = false;
                  if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                    const remainingTargets = error.error.remainingTargets;
                    this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
                  } else {
                    this.toastmessage("Something went wrong", "error");
                  }
                  this.closeActiveModal();
                })
          })
        })
      }
    } else{
      this.isLoadingEmailCampaignApi = false
    }
  }

  openAddToScreenAiModal() {
    this.modalService.open(this.addCandidateToScreenAiModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  /**
   * Get all ScreenAI jobs for the dropdown.
   */
  getAllScreenAIJobs() {
    if (!this.job_input.value) {
      this.job_input.setValue('', { emitEvent: true });
    }
  }

  /**
   * Check if a job is currently being screened.
   */
  isScreeningInProgress(job: any){
    return job.batch_status === 'pending';
  }

  /**
   * Get tooltip text for a job.
   */
  getTooltipText(job: any){
    if(job.batch_status === 'pending'){
      return 'Screening in progress, please try after sometime';
    }
    return '';
  }

  /**
   * Search ScreenAI jobs as user types.
   */
  searchJob(event: any): void {
    const query = (event.target.value || '').trim();
    this.job_input.valueChanges
    .pipe(
      debounceTime(400),            // wait for user to stop typing
      distinctUntilChanged(),       // avoid same query twice
      switchMap((query: string) => {
        const q = (query || '').trim();
        return this.atsResumeScreenService.getAllScreenAIJobsBySource(q, 'create');
      })
    )
    .subscribe((res: any) => {

      if (res.status === 'success') {
        this.jobList = res.data || [];
      }

    });
  }

  onJobSelected(value: any): void {
    this.selectedJob = value;
    this.job_input.setValue(value.name);
  }

  /**
   * Redirect to ScreenAI job listing page.
   */
  redirectToScreenAi(): void {
    if (this.selectedJob && this.selectedJob.ats_job_id) {
      this.router.navigate([`/resume-screen/candidate-listing/${this.selectedJob.ats_job_id}`]);
    } else {
      this.router.navigate(['/resume-screen']);
    }
    this.closeActiveModal();
  }

  /**
   * Add the current candidat to a ScreenAI job.
   * Performs a duplicate check first (per candidate), then calls the add API.
   */
  addToScreenAi(): void {
    this.job_input.markAllAsTouched();
    if (!this.job_input.valid || !this.selectedJob) {
      return;
    }
    this.isLoadingScreenAiApi = true;

    // this.data is the single candidate from @Input()
    const candidateToAdd = this.data;
    const candidateDetails = [{elastic_id: candidateToAdd.id, firstname: candidateToAdd.first_name, lastname: candidateToAdd.last_name, companyname: candidateToAdd.job_company_name, title: candidateToAdd.job_title}];
    const dupPayload = {
      candidateDetails,
      jobnumber: this.selectedJob.jobnumber
    };

    this.atsResumeScreenService.checkDuplicateCandidate(dupPayload).toPromise()
      .then((res: any) => {
        const results = res?.duplicateIds;

        if (results.length > 0) {
          // All are duplicates — do not proceed
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          this.addCandidateSuccess = false;
          this.postAddMssg = `${results.length === 1 ? 'This candidate is' : `${results.length} candidates are`} already present in this ScreenAI job. no new candidates will be added.`;
          return;
        }

        // No duplicate — proceed to add
        const elasticid = candidateToAdd.id || candidateToAdd.elastic_id || candidateToAdd.elasticid || '';
        const source = 'Talent Discovery';
        const addPayload = {
          jobnumber: this.selectedJob.jobnumber,
          candidateinfo: [{ elasticid, source }]
        };
        this.atsResumeScreenService.addCandidatesToScreenAI(addPayload).subscribe((addRes: any) => {
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          if (addRes && addRes.status === 'success') {
            this.addCandidateSuccess = true;
            this.postAddMssg = 'Candidate added to ScreenAI successfully.';
          } else {
            this.addCandidateSuccess = false;
            this.postAddMssg = (addRes && addRes.message) ? addRes.message : 'Something went wrong while adding to ScreenAI. Please try again.';
          }
        }, (err) => {
          console.log(err)
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          this.addCandidateSuccess = false;
          this.postAddMssg = 'Something went wrong while adding to ScreenAI. Please try again.';
        });
      })
      .catch((err) => {
        console.log(err)
        this.isLoadingScreenAiApi = false;
        this.screenAiDuplicateCheckDone = true;
        this.addCandidateSuccess = false;
        this.postAddMssg = 'Something went wrong while adding to ScreenAI. Please try again.';
      });
  }


  getContactDetails(candidateid, emailPref) {
    return new Promise((resolve, reject) => {
      let data = {
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "candidatenumber": candidateid,
      };

      this.candidateservice.getContactDetails(data).subscribe(
        (res: any) => {
          if (res.status === 'success') {

            let personalPref_email = '';
            let professionalPref_email = '';
            let targetEmailFound = '';
            const existingContactDetails = res?.data?.emails;
            if (existingContactDetails && existingContactDetails.length) {

              personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'personal')
              professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'professional')

              switch (emailPref) {
                case 1: targetEmailFound = personalPref_email;
                  break;
                case 2: targetEmailFound = professionalPref_email;
                  break;
                case 3: targetEmailFound = personalPref_email ? personalPref_email : professionalPref_email;
                  break;
                case 4: targetEmailFound = professionalPref_email ? professionalPref_email : personalPref_email;
                  break;
              }
            }
            if (targetEmailFound) {
              resolve(targetEmailFound);
            } else {
              // reject("Primary email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }
  openDetailsModal(campaign_id, payload, emailsFound, total_target){
    const modalRef =  this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.calledFor = 'email-campaign';
  }
  closeActiveModal(){
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    this.screenAiDuplicateCheckDone = false;
    this.isLoadingScreenAiApi = false;
    this.postAddMssg = '';
    this.addCandidateSuccess = false;
    this.selectedJob = null;
    this.job_input.markAsUntouched();
    this.job_input.markAsPristine();
    this.job_input.reset();
    this.jobList = []
    this.modalService.dismissAll()
  }
  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }
  getEmailPref(data){
    if(data==1){
      return 'personal';
    }
    else if(data==2){
      return 'professional';
    }
    else if(data==3){
      return 'FirstPersonal';
    }
    else{
      return 'FirstProfessional';
    }
  }
  extractPreferredEmail(details) {
    let emailPref = this.selectedCampaign['email_pref'];
    let personalPref_email = '';
    let professionalPref_email = '';
    let targetEmailFound = '';
    const existingContactDetails = details?.emails;
    if (existingContactDetails && existingContactDetails.length) {

      personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'personal')
      professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'professional')

      switch (emailPref) {
        case 1: targetEmailFound = personalPref_email;
          break;
        case 2: targetEmailFound = professionalPref_email;
          break;
        case 3: targetEmailFound = personalPref_email ? personalPref_email : professionalPref_email;
          break;
        case 4: targetEmailFound = professionalPref_email ? professionalPref_email : personalPref_email;
          break;
      }
    }
    return targetEmailFound;
  }

  getLastActivity(){
    if(this.data.lastseendate && this.data.lastcandidateactivity && this.data.lastcandidateactivity.length){
      const lastSeenDate = new Date(this.data.lastseendate);
      const lastActivityDate = new Date(this.data.lastcandidateactivity[0].createdon);

      if (lastSeenDate > lastActivityDate) {
        return 'Profile Viewed by ' + this.data.lastseenbyuser
      } else if (lastActivityDate > lastSeenDate) {
        if(this.data.lastcandidateactivity[0]?.activitytype === "Talentpool"){
          return `Added to talentpool - ${this.data.lastcandidateactivity[0]?.name}`;
        }
        return GlobalService.getPersonSearchActivityText(this.data.lastcandidateactivity[0])
      } else {
        return 'Profile Viewed by ' + this.data.lastseenbyuser
      }
    }else if(this.data.lastseendate != null){
      return 'Profile Viewed by ' + this.data.lastseenbyuser
    }else if(this.data.lastcandidateactivity && this.data.lastcandidateactivity.length){
      if(this.data.lastcandidateactivity[0]?.activitytype === "Talentpool"){
        return `Added to talentpool - ${this.data.lastcandidateactivity[0]?.name}`;
      }
      if(this.data.lastcandidateactivity[0]?.action === "add-to-screenai"){
        return `Added to ScreenAI Job - ${this.data.lastcandidateactivity[0]?.name}`;
      }
      return GlobalService.getPersonSearchActivityText(this.data.lastcandidateactivity[0])
    }
  }


  showActivity(){
    if(this.parent !== 'TalentpoolRecommendedCandidateListComponent' && (this.data && this.data.talentpoolcount >= 1) ||
      (this.data && this.data.emailcampaigncount >= 1) ||
      (this.data && this.data.lastseenbyuser !=null) || (this.data?.usedWebbtreeIntroduction) ||
      (this.data && this.data.lastcandidateactivity && this.data.lastcandidateactivity.length)){
        return true
      }else{
        return false
      }
  }

  showEmailCampaignCount(){
    if(this.data && this.data.emailcampaigncount >= 1){
      this.data.emailcampaigncount = this.data.emailcampaigncount + 1
    }else{
      this.data.emailcampaigncount = 1
    }
  }

  truncateString(string){
    if(string && string.length > 17){
      string = string.slice(0,17);
      string += '...';
    }
    return string;
  }

  openSimilarityInsights() {
    const modalRef =  this.modalService.open(SimilarityInsightsModalComponent, { size: 'lg' as 'lg', centered: true , backdrop : 'static', keyboard : false});
    modalRef.componentInstance.similarElasticId = this.similarobjectdata.data.elasticid;
    modalRef.componentInstance.candidateElasticId = this.data.id;
    modalRef.componentInstance.similarCandidateFullName = this.similarobjectdata.data.fullname;
    modalRef.componentInstance.candidateName = this.data.full_name;
    modalRef.componentInstance.referenceCandidateData = this.similarobjectdata.data;
  }
  /**
   * Used to capitalize first letter of each word
   * @param str
   * @returns
   */
  capitalizeFirstLetter(str: string): string {
     return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  }

  openJDInsights() {
    console.log(this.data, 'details');
    const modalRef =  this.modalService.open(JdinsightsModalComponent, { size: 'lg' as 'lg', centered: true , backdrop : 'static', keyboard : false});
     modalRef.componentInstance.candidateElasticId = this.data.id;
     modalRef.componentInstance.candidateName = this.data.full_name;
     modalRef.componentInstance.parsedJDKeys = this.parsedJDKeys;
  }

      redirectToEmailCampaign(campaign_id){
    this.router.navigateByUrl(`email-campaign/target-listing/${campaign_id}`);
    }
}


function getFormattedHighlights(highlight: any, totalTenure: string, currentlocation: any, region: string, candidatetotaltenure: string): MatchHighlights {
  // console.log("similarobject", this.similarobject)
  const result: MatchHighlights = {};
  if (!highlight)
    return result;

  if (highlight["experience.company.industry.keyword"]) {
    const industries: string[] = highlight["experience.company.industry.keyword"];
    result.industries = _.uniq(industries).join(", ");
  }
  if (highlight["location_locality.keyword"]) {
    const localities: string[] = highlight["location_locality.keyword"];
    result.localities = _.uniq(localities).join(", ");
  }
  if (highlight["location_name.keyword"] || highlight["location_name"]) {

    const locationNames: string[] = highlight["location_name.keyword"] || highlight["location_name"];
    const loc = currentlocation ? currentlocation.map(cl => cl.key.trim().toLowerCase().replace(/<.*?>/g, '')) : null;

    const highlightFound = (locationNames || []).find((lo: string) => lo.replace(/<.*?>/g, '').toLowerCase().trim() == loc);
    if(highlightFound) {
      result.locationNames = _.uniq(locationNames).join(", ");

    } else if(region) {
        const loc_region = region.replace(/<.*?>/g, '').toLowerCase().trim();
        const regionfound = (locationNames || []).find((lo: string) => lo.replace(/<.*?>/g, '').toLowerCase().trim().includes(loc_region));
        if(regionfound) {
          result.regionname = region;
        }
      } else {
        result.regionname = null;
      }



  }
  if (highlight["job_title"]) {
    const titles: string[] = (highlight["job_title"]);
    result.titles = titles[0].replace(/<em[^>]*>/g,'').replace(/<\/em>/g,'');
  }

  if (highlight["skills.keyword"]) {
    const skills: string[] = highlight["skills.keyword"];
    result.skills = _.uniq(skills).join(", ");
  }
  if (highlight["experience.company.name.keyword"] || highlight["experience.company.name"]) {
    const company: string[] = (highlight["experience.company.name.keyword"] || highlight["experience.company.name"]);
    result.company = company[0];
  }
  if (candidatetotaltenure && totalTenure) {
    const fromyrsofexperience = (parseInt(totalTenure) - (parseInt(totalTenure) * 0.25));
    const toyrsofexperinece = (parseInt(totalTenure) + (parseInt(totalTenure) * 0.25));
    if(parseInt(candidatetotaltenure) >= fromyrsofexperience && parseInt(candidatetotaltenure) <= toyrsofexperinece ){
      result.totalTenure = totalTenure;
    }

  }
  if (highlight["experience.company.size"]) {
    if((result.locationNames || result.regionname) && result.skills && result.totalTenure && result.titles) {
      result.companySizes = null;
    } else {
      const companySizes: string[] = highlight["experience.company.size"];
      result.companySizes = _.uniq(companySizes).join(", ");
   }

  }

  return result;


  }



